import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createProvider } from "./vue-apollo";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import VueSwal from "vue-swal";
import * as GmapVue from "gmap-vue";

Vue.use(VueMask);
Vue.use(VueSwal);
Vue.use(GmapVue, {
  load: {
    key: "AIzaSyBaU_8IGXsxiMF2lTNWfy4F9Ao9u8C4loc",
    libraries: "places,drawing",
    installComponents: true
  }
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  vuetify,
  render: h => h(App)
}).$mount("#app");
